export const SNS_TEST_LOGIN_KEY = 'SNS_TEST_LOGIN_KEY';
